import createActions from "helpers/actionCreator"
import { call, getContext, put, takeLatest } from "redux-saga/effects"
import { chain, join, pick, split, omit } from "lodash"
import { Types as GQLLoaderTypes } from "model/graphql"
import { getTracking } from "helpers/assets"
import { createDefaultReducer } from "helpers/reducers"
import { getSelectedGroup } from "./selectors"

export const { Types, Creators } = createActions("ompnt/modules/analyze-composite-asset-analytics-table", {
  hideGroup: { track: false },
  itemClick: {
    props: ["screen", "category", "item", "column"],
    ...getTracking("composite-asset"),
  },
  setMetricType: {
    props: ["metricType"],
    trackType: "composite-asset-metric-type-selected",
    trackPayload: ({ metricType }) => ({ metricType }),
  },
  setColumnOrder: {
    props: ["columnOrder"],
    track: true,
    trackType: "composite-asset-column-order-selected",
    trackPayload: ({ columnOrder }) => ({ columnOrder }),
  },
  setPage: {
    props: ["page"],
    trackType: "composite-asset-page-updated",
    trackPayload: ({ page }) => ({ page }),
  },
  setSelectedGroup: {
    props: ["id"],
    trackType: "composite-asset-grouping-selected",
    trackPayload: ({ id }) => ({ id }),
  },
  setSelectedSubView: {
    props: ["subView"],
    trackType: "composite-asset-sub-view-selected",
    trackPayload: ({ subView }) => ({ subView }),
  },
  setSelectedView: {
    props: ["id"],
    trackType: "composite-asset-view-selected",
    trackPayload: ({ id }) => ({ id }),
  },
  setSort: {
    props: ["sort"],
    trackType: "composite-asset-sort-updated",
    trackPayload: ({ sort }) => pick(sort, ["type", "id", "direction"]),
  },
}, { track: true })

function handleHideGroup(state) {
  return { ...state, selectedGroup: null }
}

function handleSetSelectedGroup(state, { id }) {
  return { ...state, selectedGroup: id, page: null }
}

function handleSetColumnOrder(state, { columnOrder }) {
  return { ...state, columnOrder: columnOrder }
}

function handleSetPage(state, { page }) {
  // page numbers to start at 1 instead of 0
  return { ...state, page: page > 0 ? page + 1 : null }
}

function handleSetSelectedViewQS(state) {
  return omit(state, ["metricType", "subView", "sort"])
}

function handleSetMetricType(state, { metricType }) {
  return { ...state, metricType }
}

export const queryStringReducers = {
  [Types.SET_COLUMN_ORDER]: handleSetColumnOrder,
  [Types.SET_SELECTED_VIEW]: handleSetSelectedViewQS,
  [Types.SET_SELECTED_SUB_VIEW]: createDefaultReducer(),
  [Types.SET_METRIC_TYPE]: handleSetMetricType,
  [Types.SET_SORT]: createDefaultReducer(),
  [Types.SET_SELECTED_GROUP]: handleSetSelectedGroup,
  [Types.HIDE_GROUP]: handleHideGroup,
  [Types.SET_PAGE]: handleSetPage,
}

function* handleGQLLoadSuccess({ resource, data }) {
  const selectedGroup = getSelectedGroup()

  if (resource === "compositeAssetAnalyticsGroupedComposition") {
    if (selectedGroup) {
      const selectedGroupExists = chain(data)
        .get("model.simulation.composition.0.compositionBy", [])
        .some(group => group.id === selectedGroup)
        .value()

      if (selectedGroupExists) {
        yield put(Creators.setSelectedGroup(selectedGroup))
      } else {
        yield put(Creators.hideGroup())
      }
    }
  } else if (resource === "compositeAssetAnalyticsComposition") {
    if (selectedGroup) {
      yield put(Creators.hideGroup())
    }
  }
}

function* handleSetSelectedView({ id }) {
  const { pathname, search } = window.location
  const pathParts = split(pathname, "/", 6)

  let url = ""
  if (id !== "summary") {
    url = `/${id}`
  }

  const { navigate } = yield getContext("router")
  yield call(navigate, `${join(pathParts, "/")}${url}${search}`)
}

export function* saga() {
  yield takeLatest(Types.SET_SELECTED_VIEW, handleSetSelectedView)
  yield takeLatest(GQLLoaderTypes.LOAD_SUCCESS, handleGQLLoadSuccess)
}
